import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class NewGroupRoute extends Route {
  @service("ember-store")
  store
  @service
  headData

  model(params) {
    this.headData.robots = "nofollow"

    return get(this, "store").find("group", params.id)
  }
}
